<template>
  <div>
    <!--banner-->
    <div class="ts_banner"></div>
    <!--/banner-->
    <!--特色-->
    <div class="wrap w1200 ts_cat">
      <a> <img src="@/assets/images/ts_cat_icon_a.png"/><br/>专属化部署 </a><a><img
      src="@/assets/images/ts_cat_icon_b.png"/><br/>深度化定制</a><a><img src="@/assets/images/ts_cat_icon_c.png"/><br/>多维度数据</a><a><img
      src="@/assets/images/ts_cat_icon_d.png"/><br/>全流程培训</a> <a> <img src="@/assets/images/ts_cat_icon_e.png"/><br/>针对性考试
    </a><a><img src="@/assets/images/ts_cat_icon_f.png"/><br/>互动性社区</a><a><img
      src="@/assets/images/ts_cat_icon_g.png"/><br/>高匹配课程</a><a><img src="@/assets/images/ts_cat_icon_h.png"/><br/>激励性积分</a>
    </div>
    <!--/特色-->
    <!--一体化服务-->
    <div class="wrap w1200 ts_yth">
      <dl class="title">
        <dt>多终端一体化服务</dt>
        <dd>多终端自由切换，贴合用户不同情况使用，跨平台服务</dd>
      </dl>
      <div class="col_1 ts_yth_left">
        <dl>
          <dt><img src="@/assets/images/ts_yth_icon_a.png"/></dt>
          <dd><p>在线考试</p>开发个性化考试方式和题型</dd>
        </dl>
        <dl>
          <dt><img src="@/assets/images/ts_yth_icon_b.png"/></dt>
          <dd><p>组织管理</p>支持自行添加、修改部门，企业微信组织架构一键同步</dd>
        </dl>
        <dl>
          <dt><img src="@/assets/images/ts_yth_icon_c.png"/></dt>
          <dd><p>数据管理</p>支持员工、部门、课程和考试等多维度数据统计</dd>
        </dl>
        <dl>
          <dt><img src="@/assets/images/ts_yth_icon_d.png"/></dt>
          <dd><p>消息管理</p>定制更合适企业的消息推送方式，推送更灵活</dd>
        </dl>
      </div>
      <div class="col_2 w636"><img src="@/assets/images/ts_yth_pic.jpg"/></div>
      <div class="clear"></div>
    </div>
    <!--/一体化服务-->
    <!--技术服务优势-->
    <div class="wrap w1200 ts_fwys">
      <p><img src="@/assets/images/ts_fwys_pic.jpg"/></p>
      <dl class="fw_icon_a">
        <dt><img src="@/assets/images/ts_fwys_icon_a.png"/></dt>
        <dd>
          <h3>专属化部署</h3>
          1、业内率先支持混合云<br/>
          2、重要数据私有化、防止泄露<br/>
          3、专属服务器宽带和储存
        </dd>
      </dl>
      <dl class="fw_icon_b">
        <dt><img src="@/assets/images/ts_fwys_icon_b.png"/></dt>
        <dd>
          <h3>深度定制开发</h3>
          1、业内率先支持混合云<br/>
          2、重要数据私有化、防止泄露<br/>
          3、专属服务器宽带和储存
        </dd>
      </dl>
      <dl class="fw_icon_c">
        <dt><img src="@/assets/images/ts_fwys_icon_c.png"/></dt>
        <dd>
          <h3>迭代式扩展</h3>1、业内率先支持混合云<br/>
          2、重要数据私有化、防止泄露<br/>
          3、专属服务器宽带和储存
        </dd>
      </dl>
      <dl class="fw_icon_d">
        <dt><img src="@/assets/images/ts_fwys_icon_d.png"/></dt>
        <dd>
          <h3>高性价比服务</h3>1、业内率先支持混合云<br/>
          2、重要数据私有化、防止泄露<br/>
          3、专属服务器宽带和储存
        </dd>
      </dl>
      <a class="ts_menu_a">技术运维支持</a><a class="ts_menu_b">数据安全保障</a><a class="ts_menu_c">高效承载能力</a><a class="ts_menu_d">高性价比服务</a>
    </div>

    <!--/技术服务优势-->
    <!--合作案例-->
    <div class="wrap w1200 ts_case">
      <h3>合作案例</h3>
      <dl>
        <dt><img src="@/assets/images/ts_case_pic1.jpg" width="394" height="258"/></dt>
        <dd>
          <p><img src="@/assets/images/ts_case_logo1.jpg" width="104" height="104"/></p>
          白玉兰在线
        </dd>
      </dl>

      <dl>
        <dt><img src="@/assets/images/ts_case_pic2.jpg" width="394" height="258"/></dt>
        <dd>
          <p><img src="@/assets/images/ts_case_logo2.jpg" width="104" height="104"/></p>
          公司名称
        </dd>
      </dl>

      <dl>
        <dt><img src="@/assets/images/ts_case_pic3.jpg" width="394" height="258"/></dt>
        <dd>
          <p><img src="@/assets/images/ts_case_logo3.jpg" width="104" height="104"/></p>
          公司名称
        </dd>
      </dl>

    </div>
    <!--/合作案例-->
    <div class="clear"></div>
  </div>
</template>
<script>

  export default {
    components: {},
    data () {
      return {}
    },
    computed: {},
    created () {
    },
    mounted () {
      this.$nextTick(() => {
      })
    },
    destroyed () {
    },
    methods: {}
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/characteristic.vue